import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import styles from './DiscoverDiscounts.module.scss'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { Button, Text } from '@percent/lemonade'
import { OffersCarousel } from '@percent/cause-dashboard/app/home/offersCarousel/OffersCarousel'
import LeftIcon from '@percent/cause-dashboard/assets/images/home/left.png'
import RightIcon from '@percent/cause-dashboard/assets/images/home/right.png'
import { useAuthState, useCausesPortalAnalytics } from '../../hooks'
import { PageViewSource } from '../../hooks/useCausesDashboardAnalytics/marketplaceAnalytics.types'

type DiscoverDiscountsProps = {
  showCarrousel?: boolean
}

const locationToPageMap: Record<string, PageViewSource> = {
  '/home': PageViewSource.Home,
  '/my-discounts': PageViewSource.MyDiscounts
}

export function DiscoverDiscounts({ showCarrousel = false }: DiscoverDiscountsProps) {
  const { authState } = useAuthState()
  const { track } = useCausesPortalAnalytics()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSeeAllDiscountsClick = () => {
    track('See all discounts button clicked', {
      organisation: authState.organisation?.displayName,
      organisationId: authState.organisation?.id,
      clickedFrom: locationToPageMap[location.pathname] || location.pathname,
      source: locationToPageMap[location.pathname] || location.pathname,
      accountId: authState.user?.id
    })
    navigate(RoutePath.PRODUCT_OFFERS)
  }

  return (
    <div className={styles.descriptionCard}>
      <img src={LeftIcon} alt="" className={styles.leftIcon} />
      <img src={RightIcon} alt="" className={styles.rightIcon} />
      <Text size="medium" fontWeight="semiBold" align="center" className={styles.upperCaseTitle} color="#0D0C0F">
        {t('typography.home.saveMoney')}
      </Text>
      <span className={styles.discountsTitle}>{t('typography.home.saveMoneyTitle')}</span>
      <Text size="large" align="center" className={styles.discountsDescription}>
        {t('typography.home.saveMoneyDescription')}
      </Text>
      <div className={styles.buttonWrapper}>
        <Button variant="primary" onClick={handleSeeAllDiscountsClick}>
          {t('typography.home.seeAllDiscountsButton')}
        </Button>
      </div>
      {showCarrousel && <OffersCarousel />}
    </div>
  )
}
